import { BaseAtlas } from './BaseAtlas';

/**
 * Auto-generated class for atlas "spritesheets/cards/backs/46_card_back_sky/46_card_back_sky"
 * Contains 1 texture(s)
 */
export class CardsBacks46CardBackSkyAtlas extends BaseAtlas {
    /**
     * Atlas path
     */
    protected static readonly ATLAS_PATH = 'spritesheets/cards/backs/46_card_back_sky/46_card_back_sky';

    /**
     * List of all available textures in atlas
     */
    protected static readonly TEXTURES = [
        '46_sky.png'
    ] as const;
}
